exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (weex-theme: colmo) {\n.container[data-v-89145938] {\n    /* background-color: #1d1f22; */\n}\n.dof-skid[data-v-89145938] {\n    /* background-color: #1d1f22; */\n}\n.swipeText[data-v-89145938] {\n    font-family: PingFangSC-Regular;\n    color: rgba(255,255,255,0.80);\n}\n}\n", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-swipe-action/colmo.css"],"names":[],"mappings":";AAAA;AACE;IACE,gCAAgC;CACjC;AACD;IACE,gCAAgC;CACjC;AACD;IACE,gCAAgC;IAChC,8BAA8B;CAC/B;CACF","file":"colmo.css","sourcesContent":["@media screen and (weex-theme: colmo) {\n  .container {\n    /* background-color: #1d1f22; */\n  }\n  .dof-skid {\n    /* background-color: #1d1f22; */\n  }\n  .swipeText {\n    font-family: PingFangSC-Regular;\n    color: rgba(255,255,255,0.80);\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-89145938","scoped":true,"hasInlineConfig":false}!./packages/dof-swipe-action/colmo.css
// module id = 238
// module chunks = 0 1